import { schema as contactCompanyDetailsSchema } from './ContactCompanyDetails.schema';
import { schema as contactCompanyInformationSchema } from './ContactCompanyInformation.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    information: contactCompanyInformationSchema(Joi, label),
    contact: contactCompanyDetailsSchema(Joi, label)
  });

export default {
  schema
};
